import React, { useContext } from 'react';
import { DefaultButton } from '@fluentui/react';
import { AdminMenuItems } from '../../helpers/MenuHelper';
import { TenantContext, UserContext } from '../../contexts/ContextWrapper';
import { useNavigate } from 'react-router-dom';

// Admin pages are customer-independent, so they all route to /:api/<page>.
const NavigationButtonAdmin: React.FC = () => {

	const { tenantContext } = useContext(TenantContext);
	const { userContext } = useContext(UserContext);

	const navigate = useNavigate();

	return (<DefaultButton
		text='Admin'
		iconProps={{ iconName: 'GlobalNavButton' }}
		menuProps={{
			items: AdminMenuItems(userContext.userData),
			onItemClick: (_ev, item) => {
				navigate(`/${tenantContext.api}/${item?.key!}`);
			},
		}}
	/>
	);
};

export default NavigationButtonAdmin;
